// Copyright © Veeam Software Group GmbH

import React, { useMemo, useState } from 'react';

import type { FC } from 'react';

import ResourcesContext from './ResourcesContext';
import resources from './';

export const ResourcesContextProvider: FC = (props): JSX.Element => {
    const [lang, change] = useState(resources.current);
    const toggleLang = (languageName: string): void => change(resources.toggleLanguage(languageName));
    const resourcesContextValue = useMemo(() => ({
        resources: lang,
        toggleLang,
    }), [lang, toggleLang]);

    return (
        <ResourcesContext.Provider value={resourcesContextValue}>
            {props.children}
        </ResourcesContext.Provider>
    );
};

